import { combineReducers } from 'redux';

import authenticationKey from './authenticationKey';
import authentications from './authentications';
import documentId from './documentId';
import guideCheckLoadingStatus from './guideCheckLoadingStatus';
import isMessageRead from './isMessageRead';
import loadingStatus from './loadingStatus';
import participantId from './participantId';
import sequences from './sequences';

const contractAuthenticationReducer = combineReducers({
  authenticationKey,
  authentications,
  documentId,
  guideCheckLoadingStatus,
  isMessageRead,
  loadingStatus,
  participantId,
  sequences,
});

export default contractAuthenticationReducer;
